// extracted by mini-css-extract-plugin
module.exports = {"selectWrapper":"CustomSelectInput_selectWrapper__31JKa"};